import { useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LiveChatWidget, useWidgetIsReady } from '@livechat/widget-react';

import { useUser } from 'hooks';
import { useContractOrAgreement } from 'hooks/useContractOrAgreement';
import { RootDispatch, RootState } from 'storage/store';
import { Token } from 'utils/Token';
import { IsLoggedIn } from 'utils/user';
import { LiveChatGroup } from 'utils/consts';
import { CHAT_BEFORE_LOGIN } from 'utils/featureTogglesNames';

const liveChatLicense = process.env.REACT_APP_LIVE_CHAT_KEY;

const LiveChatComponent = () => {
  const isWidgetReady = useWidgetIsReady();
  const dispatch = useDispatch<RootDispatch>();
  const { chatBeforeLoginEnabled } = useSelector(
    (state: RootState) => state.application
  );
  const { agreements } = useContractOrAgreement();

  const agreementIds =
    (agreements &&
      agreements.map(({ generalData }) => generalData.agreementId)) ||
    [];
  const isLoggedIn = IsLoggedIn();
  const showLiveChatWidget =
    liveChatLicense && (isLoggedIn || chatBeforeLoginEnabled);
  const { firstName, lastName, email } = useUser();
  useEffect(() => {
    dispatch.application.getFeatureToggleState(CHAT_BEFORE_LOGIN);
  }, []);
  useEffect(() => {
    const agreementTitle = 'umowa';
    const [firstAgreementId] = agreementIds;
    const agreementIdsArrayIsEmpty = agreementIds.length === 0;
    if (
      isWidgetReady &&
      isLoggedIn &&
      (window as any)?.LC_API?.set_custom_variables
    ) {
      if (agreementIdsArrayIsEmpty) {
        (window as any).LC_API.set_custom_variables([
          { name: agreementTitle, value: null }
        ]);
      }
      if (firstAgreementId) {
        (window as any).LC_API.set_custom_variables([
          { name: agreementTitle, value: firstAgreementId }
        ]);
      }
    }
  }, [agreementIds, isWidgetReady]);
  useLayoutEffect(() => {
    if (!isWidgetReady || !isLoggedIn) return;
    if (isLoggedIn) {
      (window as any).LC_API?.hide_chat_window?.();
    }
  }, [isLoggedIn, isWidgetReady]);

  if (!showLiveChatWidget) {
    return null;
  }

  const fullName = `${firstName} ${lastName}` || '';
  const { username: tokenEmail } = Token.getTokenData();
  const groupId = () => {
    if (isLoggedIn) {
      return chatBeforeLoginEnabled
        ? LiveChatGroup.loggedIn
        : LiveChatGroup.general;
    }
    return chatBeforeLoginEnabled ? LiveChatGroup.unlogged : undefined;
  };

  return (
    <LiveChatWidget
      chatBetweenGroups
      group={groupId()}
      license={liveChatLicense}
      customerName={fullName}
      customerEmail={email || tokenEmail || undefined}
    />
  );
};

export default LiveChatComponent;
